// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2YsgI","dragIcon":"SortableItem_dragIcon__1pt1e","disabled":"SortableItem_disabled__3sPNL"};